import { PestanasPagina } from '../componentes/PestanasPagina'
import { Auditoria } from './Auditoria'
import { Recalculo } from './Recalculo'
import { Configuracion } from './Configuracion'

/**
 * Sistema — fusiona Auditoría + Recálculo en una sola pantalla con pestañas.
 * Las dos son lecturas de "qué hizo el sistema solo" (sin acción humana). Cada
 * pestaña es direccionable por ?tab=.
 */
export function Sistema() {
  return (
    <PestanasPagina
      titulo="Sistema"
      descripcion="Qué ha ejecutado el sistema por su cuenta: auditoría de procesos y recálculo de etiquetas."
      pestanas={[
        { id: 'auditoria', etiqueta: 'Auditoría', render: () => <Auditoria sinCabecera /> },
        { id: 'recalculo', etiqueta: 'Recálculo de etiquetas', render: () => <Recalculo sinCabecera /> },
        { id: 'configuracion', etiqueta: 'Configuración', render: () => <Configuracion /> },
      ]}
    />
  )
}
